import styled from 'styled-components';
import { colours } from '@cambridgeassessment/cambridge-ui';
import { Tooltip, makeStyles, withStyles } from '@material-ui/core';

export const ExplanatoryText = styled.div`
  width: 624px;
  color: ${colours.nevada};
  font-size: 14px;
  line-height: 1.36;
  margin-top: 8px;
`;

export const useStyles = makeStyles({
  root: {
    fontSize: '16px',
  },
});

interface Props {
  display?: boolean;
}

export const StyledTooltip = withStyles({
  popper: {
    marginLeft: '-150px',
    marginBottom: '-5px',
    display: (props: Props) => (props.display ? 'block' : 'none'),
  },
  arrow: {
    color: colours.black,
  },
  tooltip: {
    backgroundColor: colours.black,
    fontFamily: 'Roboto',
    fontSize: '12px',
    padding: '12px 8px 12px 8px',
  },
})(Tooltip);
